module.exports = __webpack_public_path__ + "img/kehu_9@2x.7e3e27eb.png";